import React, { useEffect, useState, useContext } from 'react';
import { db } from '../../../firebase';
import { Link } from 'react-router-dom';
import { collection, getDocs, doc, updateDoc } from 'firebase/firestore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPlus } from '@fortawesome/free-solid-svg-icons';
import EditPermissionModal from './EditPermissionModal';
import AddPermissionModal from './AddPermissionModal';
import ReactPaginate from 'react-paginate';
import { UserContext } from '../../../contexts/UserContext';

const Permissions = () => {
    const [permissions, setPermissions] = useState([]);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [selectedPermission, setSelectedPermission] = useState(null);
    const [nameFilter, setNameFilter] = useState('');
    const { user } = useContext(UserContext);

    // Pagination states
    const [currentPage, setCurrentPage] = useState(0);
    const permissionsPerPage = 10; // Adjust the number of permissions per page

    useEffect(() => {
        const fetchPermissions = async () => {
            try {
                const permissionsCollection = collection(db, 'permissions');
                const permissionsSnapshot = await getDocs(permissionsCollection);
                let permissionsList = permissionsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));

                // Apply name filter
                if (nameFilter) {
                    permissionsList = permissionsList.filter(permission =>
                        permission.nom.toLowerCase().includes(nameFilter.toLowerCase())
                    );
                }

                setPermissions(permissionsList);
            } catch (error) {
                console.error("Error fetching permissions: ", error);
            }
        };

        fetchPermissions();
    }, [nameFilter]);

    // Calculate pagination data
    const indexOfLastPermission = (currentPage + 1) * permissionsPerPage;
    const indexOfFirstPermission = indexOfLastPermission - permissionsPerPage;
    const currentPermissions = permissions.slice(indexOfFirstPermission, indexOfLastPermission);
    const pageCount = Math.ceil(permissions.length / permissionsPerPage);

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    const handleShowEdit = (permission) => {
        setSelectedPermission(permission);
        setShowEditModal(true);
    };

    const handleSave = async (updatedPermission) => {
        try {
            const permissionDoc = doc(db, 'permissions', updatedPermission.id);
            await updateDoc(permissionDoc, updatedPermission);
            setPermissions(prevPermissions =>
                prevPermissions.map(p =>
                    p.id === updatedPermission.id ? updatedPermission : p
                )
            );
        } catch (error) {
            console.error("Error updating permission: ", error);
        }
    };

    const handleAdd = (newPermission) => {
        setPermissions(prevPermissions => [...prevPermissions, newPermission]);
    };

    return (
        <div id="content-wrapper" className="d-flex flex-column">
            <div id="content">
                <div className="container-fluid">
                    {user && user.role === 'L1QUmxerXDdx3DbWgY5H' && (
                        <button className="btn btn-red2 ml-auto" onClick={() => setShowAddModal(true)}>
                            <FontAwesomeIcon icon={faPlus} /> Ajouter une permission
                        </button>
                    )}
                    <p className="mb-4"></p>
                    <div className="card shadow mb-4">
                        <div className="card-header py-3 d-flex justify-content-between align-items-center">
                            <h6 className="m-0 font-weight-bold title-2 mr-2">Permissions</h6>
                            <input
                                    type="text"
                                    className="form-control w-25"
                                    placeholder="Filtrer par nom"
                                    value={nameFilter}
                                    onChange={(e) => setNameFilter(e.target.value)}
                                />
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-bordered" id="dataTable" width="100%">
                                    <thead>
                                        <tr>
                                            <th>Nom</th>
                                            <th>Description</th>
                                            <th>État</th>
                                            {user && user.role === 'L1QUmxerXDdx3DbWgY5H' && (
                                                <th>Action</th>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentPermissions.map((permission) => (
                                            <tr key={permission.id}>
                                                <td>{permission.nom}</td>
                                                <td>{permission.description}</td>
                                                <td>
                                                    <span className={permission.active ? 'text-success' : 'text-danger'}>
                                                        {permission.active ? 'Activé' : 'Désactivé'}
                                                    </span>
                                                </td>
                                                {user && user.role === 'L1QUmxerXDdx3DbWgY5H' && (
                                                    <td>
                                                        <Link className="btn btn-primary btn-circle btn-sm ml-2" to="#" onClick={() => handleShowEdit(permission)}>
                                                            <FontAwesomeIcon icon={faEdit} />
                                                        </Link>
                                                    </td>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <ReactPaginate
                                    previousLabel={'Précédent'}
                                    nextLabel={'Suivant'}
                                    breakLabel={'...'}
                                    breakClassName={'page-item'}
                                    breakLinkClassName={'page-link'}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={handlePageClick}
                                    containerClassName={'pagination justify-content-start'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link'}
                                    previousClassName={'page-item'}
                                    previousLinkClassName={'page-link'}
                                    nextClassName={'page-item'}
                                    nextLinkClassName={'page-link'}
                                    activeClassName={'active'}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
            {selectedPermission && (
                <EditPermissionModal
                    show={showEditModal}
                    handleClose={() => setShowEditModal(false)}
                    permission={selectedPermission}
                    handleSave={handleSave}
                />
            )}
            <AddPermissionModal
                show={showAddModal}
                handleClose={() => setShowAddModal(false)}
                handleSave={handleAdd}
            />
        </div>
    );
};

export default Permissions;
